import { GridFilterItemPro } from './filterModelPro'
import { GridColDefPro } from './types'

/**
 * Filtro com que a tabela abre: link compartilhado > escolha salva do usuário >
 * padrão da tela. Salvo vazio é escolha (o usuário limpou o filtro), não ausência.
 */
export function resolverFiltroInicial(
    daUrl: GridFilterItemPro[] | undefined,
    salvo: GridFilterItemPro[] | undefined,
    padrao: GridFilterItemPro[],
) {
    if (daUrl?.length) return daUrl
    return salvo ?? padrao
}

/** Filtro salvo antes de uma coluna sair do grid não pode ser aplicado pela metade. */
export function citaColunaInexistente(
    items: GridFilterItemPro[],
    colunas: Pick<GridColDefPro, 'field'>[],
) {
    const campos = new Set(colunas.map(coluna => coluna.field))
    return items.some(item => !campos.has(item.columnField))
}
